export enum SocketEvent {
  CONNECT = "connect",
  MESSAGE = "message",
  AUTHENTICATE = "authenticate",
}
